export default __webpack_public_path__ + "c9ebda97620575629ea5eabc5dee8810.svg";